import SKStoreLogo from 'assets/icons/sk-store/logo.svg';
import { PaymentStatus } from 'constants/payment';
import { useAmount, useIsMobile, useTranslate } from 'hooks';
import { useAppSelector } from 'store/hooks';
import { twMergeClsx, costFormat } from 'utils';
import { AmountForm } from 'views/forms/base/amount-field';
import { PaymentBoxModal } from 'views/modals/base/payment-box-modal';

const CompanyInfo = () => {
  const { paymentData, acquiring } = useAppSelector((state) => state.payment);
  const { formattedAmountWithCurrency } = useAmount();
  const { isMobile } = useIsMobile();
  const { t } = useTranslate();

  if (!paymentData) {
    return null;
  }

  return (
    <div
      className={twMergeClsx(
        'md:max-w-[345px] flex-grow w-full h-full md:py-20 md:px-[60px] flex flex-col md:justify-center gap-5 bg-white md:rounded-l-large relative',
        paymentData.status === PaymentStatus.PAYMENT_SUCCESS && 'md:max-w-[unset]',
      )}
    >
      {isMobile ? (
        <>
          {!acquiring && (
            <>
              <div className="px-4 md:p-0 flex flex-col items-center justify-center md:items-start md:justify-normal md:flex-col gap-2 md:gap-6">
                <img src={SKStoreLogo} className="h-14" alt="cart" />
                <h2 className="text-base md:text-xl font-bold leading-5 md:leading-6 text-black">
                  {paymentData?.contragentName}
                </h2>
              </div>
              <div className="flex flex-col gap-3 px-4 md:p-0">
                <dl className="flex justify-between font-semibold items-center">
                  <dt className="text-sm text-base-gray-800 leading-140">
                    {t('lang.order_number')}
                  </dt>
                  <dd className="text-base leading-140">{paymentData?.ID}</dd>
                </dl>
                {!paymentData?.fix && paymentData?.status === PaymentStatus.WAIT_PAYMENT ? (
                  <dl className="flex justify-between font-semibold items-center flex-1">
                    <dt className="text-sm text-base-gray-800 w-full leading-140">
                      {t('amount')}, ₸ <span className="text-base-red-100 opacity-50">*</span>
                    </dt>
                    <dd className="text-base leading-140 w-full">
                      <AmountForm />
                    </dd>
                  </dl>
                ) : (
                  <dl className="flex justify-between font-semibold items-center flex-1">
                    <dt className="text-sm text-base-gray-800 w-full leading-140">
                      {t('lang.amount')}, ₸
                    </dt>
                    <dd className="text-base leading-140 w-full text-right">
                      {formattedAmountWithCurrency('')}
                    </dd>
                  </dl>
                )}
              </div>
            </>
          )}
          <div
            className={twMergeClsx(
              'md:hidden flex-col flex items-end p-4 border-t border-base-gray-500',
              acquiring ? 'flex-grow' : 'mt-auto',
            )}
          >
            <PaymentBoxModal />
          </div>
        </>
      ) : (
        <>
          <div className="flex items-center justify-center md:items-start md:justify-normal flex-col gap-2 md:gap-6">
            <img src={SKStoreLogo} width={183} alt="cart" />
            {paymentData.description && (
              <h2 className="text-lg md:text-xl font-bold leading-6 text-black">
                {paymentData.description}
              </h2>
            )}
          </div>
          <div className="flex flex-col gap-2 flex-grow md:ml-8">
            {paymentData.metadata &&
              Object.entries(paymentData.metadata).map(([key, value]) => (
                <dl className="company-info__detail-container" key={key}>
                  <dt className="text-lg leading-5 mb-1 text-skstore-gray-100">{key}:</dt>
                  <dd className="text-lg leading-5 font-semibold text-back">{value}</dd>
                </dl>
              ))}
          </div>
          <div
            className={twMergeClsx(
              'flex flex-col gap-5 items-center text-center md:text-left md:items-start',
              paymentData.status === PaymentStatus.PAYMENT_SUCCESS && 'md:items-end',
            )}
          >
            {!paymentData?.fix && paymentData?.status === PaymentStatus.WAIT_PAYMENT ? (
              <AmountForm />
            ) : (
              <>
                <dl>
                  <dt className="text-[10px] leading-3 mb-1 block uppercase font-nunito font-semibold text-base-dark-gray-200/60">
                    {t('lang.amount')}
                  </dt>
                  <dd className="bg-[transparent] w-full outline-none font-bold text-2xl leading-7">
                    {paymentData?.fix
                      ? costFormat(Math.abs(Number(paymentData.amount)))
                      : costFormat(Math.abs(Number(paymentData?.amount)))}{' '}
                    KZT
                  </dd>
                </dl>
                {Math.abs(Number(acquiring?.commission)) > 0 && (
                  <dl>
                    <dt className="text-[10px] leading-3 mb-1 block uppercase font-nunito font-semibold text-base-dark-gray-200/60">
                      КОМИССИЯ
                    </dt>
                    <dd className="bg-[transparent] w-full outline-none font-bold text-2xl leading-7">
                      {costFormat(Math.abs(Number(acquiring?.commission)))} KZT
                    </dd>
                  </dl>
                )}
              </>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export { CompanyInfo };
